import axios from 'axios';

import { AuthenticationClient } from '../authentication/client';
import { logger } from '../logging';

import { FILTERS_URL } from './utils';
import { UserFilter } from './types';

export const deleteFilter = async (filter: UserFilter) => {
  try {
    const token = await AuthenticationClient.getInstance().getAccessToken();

    await axios.delete(`/v2/filters/${encodeURIComponent(filter.id)}`, {
      baseURL: FILTERS_URL,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (e) {
    logger.error(e);
    throw e;
  }
};
